import React, { useEffect, useRef } from 'react';
import _get from 'lodash/get';
import { toggleBubbleOpen, setSlideKey, trackButtonName, State } from 'store/onboarding';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import useTaskList from 'components/onboarding/useTaskList';
import classNames from 'classnames';
import makeStyles from '@material-ui/core/styles/makeStyles';

import Paper from '@material-ui/core/Paper';
import Checklist from 'components/onboarding/Checklist';
import TaskDetail from 'components/onboarding/TaskDetail';
import CelebrationCheers from 'components/onboarding/CompletionCheers';

import { LIST_SLIDE_KEY, CHEERS_SLIDE_KEY } from 'components/onboarding/constants';

function getBubbleComponent(slideKey: string) {
  if (slideKey === LIST_SLIDE_KEY) {
    return <Checklist />;
  }

  if (slideKey === CHEERS_SLIDE_KEY) {
    return <CelebrationCheers />;
  }

  return <TaskDetail />;
}

function Bubble() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const overlayRef = useRef<any>();

  const taskList = useTaskList();
  const location = useLocation();

  const onboardingState: State = useSelector((state: any) => state.onboarding);
  const onScreenTask = taskList && taskList.find(t => location.pathname.includes(t.pageStartUrl));
  const {
    bubbleOpen: open,
    slideKey,
    prevSlideKey,
    taskButtonRef,
    percentageButtonRef,
  } = onboardingState;

  useEffect(() => {
    const onScreenTaskId = onScreenTask && onScreenTask.id;

    if (onScreenTaskId && onScreenTaskId !== prevSlideKey) {
      dispatch(setSlideKey(onScreenTaskId));
    }
  }, [location.pathname]);

  const clickOutsideBubble = (e: any) => {
    const clickIsOutOfBubble = overlayRef.current && !overlayRef.current.contains(e.target);
    const clickIsOutOfTaskButton = !_get(taskButtonRef, 'current')
      ? true
      : Boolean(taskButtonRef.current && !taskButtonRef.current.contains(e.target));

    const clickIsOutOfPercentageButton =
      percentageButtonRef &&
      percentageButtonRef.current &&
      !percentageButtonRef.current.contains(e.target);

    if (open && clickIsOutOfBubble && clickIsOutOfTaskButton && clickIsOutOfPercentageButton) {
      dispatch(toggleBubbleOpen(false));
      dispatch(trackButtonName(null));
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', clickOutsideBubble);

    return () => document.removeEventListener('mousedown', clickOutsideBubble);
  }, [open]);

  const Component: React.ReactNode = getBubbleComponent(slideKey);

  return (
    <Paper className={classNames(classes.root, { [classes.bubbleOpen]: open })} elevation={3}>
      {open && (
        <div className={classes.content} data-testid="bubble-content" ref={overlayRef}>
          {Component}
        </div>
      )}
    </Paper>
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    position: 'fixed',
    right: theme.spacing(),
    top: theme.spacing(8.125),
    width: 400,
    // @ts-ignore
    zIndex: theme.zIndex.surface,
  },
  stickyHeader: {
    position: 'sticky',
    top: 0,
    backgroundColor: theme.palette.common.white,
    zIndex: theme.zIndex.appBar,
  },
  bubbleOpen: {
    maxHeight: 500,
    overflow: 'auto',
  },
  divider: {
    marginLeft: 0,
    width: '100%',
  },
  content: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

export default Bubble;
